//@ts-nocheck
import {DeviceTransactionResult, TransactionResult} from "./transaction-result";
import {Observable, Subject} from "rxjs";
import {catchError, timeout} from "rxjs/operators";
import {of} from "rxjs/internal/observable/of";
import {MultiTargetTransaction, SingleTargetTransaction, Transaction} from "./transaction";



export class EventSocket {
  private connectionEstablished: Subject<any> = new Subject();
  private deviceChangeEvents: Subject<any> = new Subject();

  constructor(public socket: SocketIOClient.Socket) {
    socket.on('outdated', () => {
        // this only occurs when we tell OpenSTF to make it happen, so there should be no need to handle this
    });

    socket.on('socket.ip', (ip) => {
        // this tells us that a connection has been established
      this.connectionEstablished.next(ip);
      this.connectionEstablished.complete();
    });
  }

  public waitForConnection(): Observable<boolean> {
    return this.connectionEstablished;
  }

  public subscribeToDeviceEvents(): Observable<any> {
    this.socket.off('device.change');

    this.socket.on('device.change', (event) => {
      this.deviceChangeEvents.next(event);
    });

    return this.deviceChangeEvents;
  }



  public createTransaction(target: any, options?): Transaction {
    if (options && !options.result) {
      options.result = ((tgt) => new TransactionResult(tgt));
    }

    if (Array.isArray(target)) {
      return this.createMultiTargetTransaction(target, options);
    } else {
      return this.createSingleTargetTransaction(target, options);
    }
  }

  public createSingleTargetTransaction(target: any, options?): SingleTargetTransaction {
    return new SingleTargetTransaction(target,
      options || {result: (tgt) => new DeviceTransactionResult(tgt), id: 'serial'},
        this.socket);
  }

  public createMultiTargetTransaction(target: Array<any>, options?): MultiTargetTransaction {
    return new MultiTargetTransaction(target,
      options || {result: (tgt) => new DeviceTransactionResult(tgt), id: 'serial'},
      this.socket);
  }



  public punch(channel) {
    const subject: Subject<any> = new Subject();

    function punchListener(someChannel) {
      if (channel === someChannel) {
        subject.next(channel);
        subject.complete();
      }
    }

    this.socket.on('tx.punch', punchListener);
    this.socket.emit('tx.punch', channel);

    return subject.pipe(
      timeout(5000),
      catchError(error => of(`Request for channel ${channel} timed out after 5000 ms`))
    ).subscribe(
      () => {},
      () => {},
      () => { this.socket.removeListener('tx.punch', punchListener); }
    );
  }

  public emit(action, channel, channelOrData, data?) {
    if (data) {
      return this.socket.emit(action, channel, channelOrData, data);
    } else {
      return this.socket.emit(action, channel, channelOrData);
    }
  }

}
